<script>
  import {
    SALE_END_DATE,
    SALE_START_DATE,
    SALE_START_DATE_FMT,
    WEEKLY_BLOCK_RANGE,
  } from "../util/constants";
  import dateformat from "dateformat";

  const shortFormat = "GMT:dd/mm HH:MM Z";
  // const start = dateformat(date, "GMT:mmm dd, yyyy h:MM TT" + (timezone ? " Z" : ""));
</script>

<div class="table">
  <div class="labels">
    <div class="label week">Week</div>
    <div class="label from">From</div>
    <div class="label to">To</div>
  </div>
  <div class="week-row">
    <div class="cell week">1</div>
    <div class="cell from">
      <div class="date">{dateformat(SALE_START_DATE, shortFormat)}</div>
    </div>
    <div class="cell to">
      <div class="number">block {WEEKLY_BLOCK_RANGE[1] - 1}</div>
    </div>
  </div>
  <div class="week-row">
    <div class="cell week">2</div>
    <div class="cell from">
      <div class="number">block {WEEKLY_BLOCK_RANGE[1]}</div>
    </div>
    <div class="cell to">
      <div class="number">block {WEEKLY_BLOCK_RANGE[2] - 1}</div>
    </div>
  </div>
  <div class="week-row">
    <div class="cell week">3</div>
    <div class="cell from">
      <div class="number">block {WEEKLY_BLOCK_RANGE[2]}</div>
    </div>
    <div class="cell to">
      <div class="number">block {WEEKLY_BLOCK_RANGE[3] - 1}</div>
    </div>
  </div>
  <div class="week-row">
    <div class="cell week">4</div>
    <div class="cell from">
      <div class="number">block {WEEKLY_BLOCK_RANGE[3]}</div>
    </div>
    <div class="cell to">
      <div class="date">{dateformat(SALE_END_DATE, shortFormat)}</div>
    </div>
  </div>
</div>

<style>
  .table {
    font-size: 12px;
    width: 100%;
    --cell-width: 100px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .labels {
    gap: 10px;
    display: flex;
    flex-direction: row;
    width: 100%;
    border-bottom: 1px solid black;
  }
  .label {
  }
  .week-row {
    gap: 10px;
    display: flex;
    flex-direction: row;
    border-bottom: 1px dotted black;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .week {
    flex-basis: 50px;
  }
  .from,
  .to {
    flex-basis: 150px;
  }
</style>
